import React from 'react';

const COPY = {
  not_found: {
    message: 'Esta carpeta ya no está disponible',
    actionLabel: 'Volver a la raíz'
  },
  server: {
    message: 'No se pudo cargar el contenido, inténtalo de nuevo',
    actionLabel: 'Reintentar'
  },
  forbidden: {
    message: 'No tienes permiso para ver esta sección',
    actionLabel: null
  }
};

const FileExplorerErrorState = ({ kind, onAction }) => {
  const copy = COPY[kind] || COPY.server;

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 px-4 text-center text-content">
      <p>{copy.message}</p>
      {copy.actionLabel && (
        <button
          type="button"
          onClick={onAction}
          className="px-4 py-2 rounded-md bg-amber hover:bg-amber-hover text-on-amber text-sm font-medium transition-colors"
        >
          {copy.actionLabel}
        </button>
      )}
    </div>
  );
};

export default FileExplorerErrorState;
